import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectfetchWorkTicketLoading, selectFilteredWorkTickets, selectWorkTicketLoading } from './store/selectors';
import { editWorkTicketData } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const WorkTicketTable = () => {
  const dispatch = useDispatch();

  const { filteredData, isLoading, isFetchDataLoading } = useSelector(state => ({
    filteredData: selectFilteredWorkTickets(state),
    isLoading: selectWorkTicketLoading(state),
    isFetchDataLoading: selectfetchWorkTicketLoading(state),
  }));

  const handleEditClick = record => {
        dispatch(editWorkTicketData(record.workorderid));
  };

  const columns = [
    {
      title: 'Work Order ID',
      dataIndex: 'workorderid',
      sorter: (a, b) => a.workorderid.length - b.workorderid.length,
    },
    {
      title: 'Company/Firm',
      dataIndex: 'firm',
      sorter: (a, b) => a.firm.length - b.firm.length,
    },
    {
      title: 'Work Ticket Name',
      dataIndex: 'wtname',
       sorter: (a, b) => a.wtname.length - b.wtname.length,
    },

    {
      title: 'Material ID',
      dataIndex: 'materiaL_ID',
        sorter: (a, b) => a.materiaL_ID.length - b.materiaL_ID.length,
    },
    {
      title: 'Cycle',
      dataIndex: 'cycle',
        sorter: (a, b) => a.cycle.length - b.cycle.length,
    },
    {
      title: 'Operator',
      dataIndex: 'operator',
       sorter: (a, b) => a.operator.length - b.operator.length,
    },
   
    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
                  <i data-feather="trash-2" className="feather-trash-2"></i>
                </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default WorkTicketTable;
